export default "https://assets.egbcdn.net/assets/packs/_/images/matches/man-mobile-955050b2dbf4b36ff2e5152a9c688eb5.png";